


































































































































import TextInput from '@/components/interviews/report/TextInput.vue'
import Artifacts from '@/components/Artifacts'
import { NoUndefinedVariables } from 'graphql/validation/rules/NoUndefinedVariables'
import Vue from 'vue'
import DatePicker from '@/components/workflow/Datepicker.vue'
import CounselingQuestionTexts from '@/components/counseling/CounselingQuestionTexts.vue'

export default Vue.extend({
  //load the counseling questions for property
  components: {
    DatePicker,
    TextInput,
    CounselingQuestionTexts,
  },
  methods: {
    save() {
      try {
        this.$store.dispatch({ type: 'counselingQuestions/save', entity: this.answer })
        return true
      } catch (e) {
        window.alert(`Error ${e.message}`)
        return false
      }
    },
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    timeOfMeasurement: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const data = this.$store.getters['counselingQuestions/findBy']({
      case_id: this.caseId,
      time_of_measurement: this.timeOfMeasurement,
      step: 'correction',
    })
    if (!data) {
      this.answer = {
        case_id: this.caseId,
        time_of_measurement: this.timeOfMeasurement,
        step: 'correction',
        main_problem: this.counselingQuestions.main_problem,
        effects_on_daily_life: this.counselingQuestions.effects_on_daily_life,
        expected_result: this.counselingQuestions.expected_result,
        solution_progress: this.counselingQuestions.solution_progress,
        submitter_id: this.$store.getters.currentUserId,
        contact_date: new Date().toISOString(),
        contact_via: null,
      }
    } else {
      this.answer = data
    }
  },
  data() {
    return {
      diagnosis: 'accept',
      answer: null,
    }
  },
  computed: {
    counselingQuestions(): any {
      const data = this.$store.getters['counselingQuestions/findBy']({
        case_id: this.caseId,
        time_of_measurement: this.timeOfMeasurement,
        step: 'initial',
      })
      return data
    },
    where(): object {
      return { case_id: this.caseId, step: 'correction' }
    },
    contactDate: {
      get() {
        return new Date(this.answer.contact_date)
      },
      set(value: Date) {
        if (value) {
          this.answer.contact_date = value.toISOString()
        } else {
          this.answer.contact_date = null
        }
      },
    },
  },
})
